var map = {
	"./clients.ts": "aca5",
	"./dashboard.ts": "8e64",
	"./eventLog.ts": "2a46",
	"./index.ts": "0613",
	"./menu.ts": "c50b",
	"./notice.ts": "22fe",
	"./place.ts": "9c25",
	"./pos.ts": "264c",
	"./settings.ts": "cf0c",
	"./sockets.ts": "20df",
	"./storehouse.ts": "be66",
	"./takeAway.ts": "b754",
	"./timer.ts": "a961",
	"./user.ts": "21d1",
	"./userDevice.ts": "4ba3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6d19";